// function to get refund if any, after paying full amount
export const getPaidAmountRefund = (
  totalAmountPaid,
  totalFees,
  totalPaidPartialAmount,
  appointmentDetails
) => {
  let onlyOnlineAmount =
    appointmentDetails?.length > 0
      ? appointmentDetails.reduce(
          (a, v) =>
            a +
            (v?.payment_method !== "Paid at Clinic - By Cash" &&
              +v?.partial_amount === 0 &&
              v.total_fee_in_rupees),
          0
        )
      : 0;
  let onlinePaidAmount =
    getValueUpto2DecimalPlaces(totalPaidPartialAmount) +
    getValueUpto2DecimalPlaces(onlyOnlineAmount);

  return getValueUpto2DecimalPlaces(
    +(
      getValueUpto2DecimalPlaces(totalAmountPaid) +
      +onlinePaidAmount -
      (totalFees ?? 0)
    )
  );
};

export const convertToBoolean = (val) => {
  return val === true || val?.toLowerCase() === "true";
};

export const getValueUpto2DecimalPlaces = (val) => {
  return val ? parseFloat((Math.round(val * 100) / 100)?.toFixed(2)) : 0;
};

export const calculateTotalOnlinePayedAmount = (appointments) => {
  let totalOnlinePayedAmountList = appointments?.filter(
    (data) =>
      data.partial_amount == 0 &&
      data.payment_method !== "Paid at Clinic - By Cash"
  );
  let totalOnlinePayedAmount = 0;
  if (totalOnlinePayedAmountList?.length > 0) {
    totalOnlinePayedAmount = totalOnlinePayedAmountList.reduce(
      (a, v) => a + v.consultation_fee_in_rupees,
      0
    );
    let totalDiscount = totalOnlinePayedAmountList.reduce(
      (a, v) => a + v.discount_on_consultation_fee_in_rupees,
      0
    );
    totalOnlinePayedAmount = totalOnlinePayedAmount - totalDiscount;
  }
  return totalOnlinePayedAmount;
};
